import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { selectors as ApplicationsSelectors } from 'data/applications'

import {
  makesPaginatedQueries,
  pageAndDataFetched,
  resetList,
  fetchPageStart,
  fetchPageError,
} from 'data/graphql'

const LIST_NAME = ApplicationsSelectors.APPLICATIONS_LIST_NAME

const applicationsQuery = gql`
  query getApplications($input: GetApplicationsInput!) {
    getApplications(input: $input) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          __typename
          id
          name
          photoURL
          description
          installationUrls {
            organization
          }
          features
        }
      }
    }
  }
`

function fetchPaginatedApplications() {
  return compose(
    connect(
      null,
      {
        pageAndDataFetched,
        resetList,
        fetchPageStart,
        fetchPageError,
      }
    ),
    makesPaginatedQueries({
      resetOnUnmount: true,
      query: applicationsQuery,
      getVariables: ({ listState }) => ({ options }) => {
        const endCursor =
          listState && !options.startFresh ? listState.pageInfo.endCursor : null
        return {
          input: {
            pagination: {
              first: 50,
              after: endCursor,
            },
          },
        }
      },
      getOnReset: ({ resetList }) => () => resetList(LIST_NAME),
      getOnFetchStart: ({ fetchPageStart }) => ({ meta }) =>
        fetchPageStart(LIST_NAME, meta),
      getOnFetchSuccess: ({ pageAndDataFetched }) => ({ result, options }) => {
        pageAndDataFetched(LIST_NAME, result.data.getApplications, options)
      },
      getOnFetchError: ({ fetchPageError }) => error =>
        fetchPageError(LIST_NAME, error),
    })
  )
}

export default fetchPaginatedApplications
